import { useState } from 'react'
import { Image } from './image'

const CATEGORIES = ['All', 'Residential', 'Commercial', 'Industrial']

export const Gallery = (props) => {
  const [active, setActive] = useState('All')
  const items = props.data
    ? (active === 'All' ? props.data : props.data.filter(d => d.category === active))
    : []

  return (
    <div id='portfolio' className='text-center'>
      <div className='container'>
        <div className='section-title'>
          <h2>Our Projects</h2>
          <p>A glimpse of the solar installations we have delivered — from family homes to industrial campuses.</p>
        </div>

        {/* Filter buttons */}
        <div className='gallery-filters'>
          {CATEGORIES.map(cat => (
            <button
              key={cat}
              className={`gallery-filter-btn${active === cat ? ' active' : ''}`}
              onClick={() => setActive(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className='row'>
          <div className='portfolio-items'>
            {items.length > 0
              ? items.map((d, i) => (
                  <div key={`${d.title}-${i}`} className='col-sm-6 col-md-4 col-lg-4'>
                    <Image title={d.title} largeImage={d.largeImage} smallImage={d.smallImage} />
                  </div>
                ))
              : <p style={{ color: '#888', marginTop: 20 }}>No projects in this category yet.</p>
            }
          </div>
        </div>
      </div>
    </div>
  )
}
